import { render, staticRenderFns } from "./LexBot.vue?vue&type=template&id=51c04c0b"
import script from "./LexBot.vue?vue&type=script&lang=js"
export * from "./LexBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports